import * as modal from './modal';
import * as func from './func';
import * as button from './button';

$(function () {

    // 送信（Submit）
    $("#share_submit").on("click", function () {
        // ボタンを無効に
        button.invalid(this);

        // メール送信
        sendUrlMail(document.forms["share_Form"], this);
    });

    // QRコードボタン
    $('#qrcode_icon').on("click", function () {
        $('#qrcode').toggle();
    });

    // コピーボタン
    $('#copybutton').on("click", function () {
        func.onClickCopy();
    });

    // ツールチップ表示
    $('[data-toggle="tooltip_share"]')
        // Tooltipの設定
        .tooltip({
            trigger: 'manual'
        })
        // Tooltip表示後の動作を設定
        .on('shown.bs.tooltip', function () {
            setTimeout((function () {
                $(this).tooltip('hide');
            }).bind(this), 2000);
        })
        // クリック時の動作を設定
        .on('click', function () {
            $('.tooltip').css('display', 'inline-block');
            $(this).tooltip('show'); // Tooltipを表示する
        });
});

// メール送信
function sendUrlMail(formData, thisElem) {
    $.ajax({
        type: 'POST',
        url: mypath + 'sendurl',
        data: $(formData).serialize(),
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {
                // ボタンを有効に
                button.valid(thisElem);

                if (res['flag']) {
                    Swal.fire({
                        title: '送信完了',
                        text: 'URLを送信しました。',
                        confirmButtonText: 'OK'
                    });
                    // モーダルを閉じる
                    modal.startScroll();
                    $('.overlay_modal').fadeOut();
                } else {
                    Swal.fire({
                        title: 'エラー',
                        text: '送信に失敗しました',
                        confirmButtonText: 'OK'
                    });
                    console.log(res['error']);
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {
                // ボタンを有効に
                button.valid(thisElem);

                // バリデーションエラー
                if (XMLHttpRequest.responseJSON.errors) {
                    Swal.fire({
                        title: '入力エラー',
                        text: '入力内容に誤りがあります',
                        confirmButtonText: 'OK'
                    });
                }
            });
}
